export const MIN_PROJECTS_COUNT = 4;
